module.exports = __webpack_public_path__ + "static/media/init-state.c0dc8921.svg";